<template>
  <div class="share-tools" :class="className">
    <div class="share-tools-text">share</div>
    <BaseButton
      class="share-tools-button"
      variant="twitter"
      rounded="full"
      aria-label="Share this News Article on Twitter"
    >
      <twitter-logo/>
    </BaseButton>
    <BaseButton
      class="share-tools-button"
      variant="facebook"
      rounded="full"
      aria-label="Share this News Article on Facebook"
    >
      <facebook-logo/>
    </BaseButton>
    <BaseButton
      class="share-tools-button"
      variant="linkedin"
      rounded="full"
      aria-label="Share this News Article on LinkedIn"
    >
      <linkedin-logo/>
    </BaseButton>
    <BaseButton
      class="share-tools-button"
      variant="google"
      rounded="full"
      aria-label="Share this News Article on Google"
    >
      <google-logo/>
    </BaseButton>
    <BaseButton
      class="share-tools-button"
      variant="email"
      rounded="full"
      aria-label="Share this News Article via Email"
    >
      <BaseIcon name="email" size="20"></BaseIcon>
    </BaseButton>
  </div>
</template>

<script>
import BaseIcon from '../elements/BaseIcon.vue'
import BaseButton from '../elements/BaseButton.vue'
import TwitterLogo from '@/assets/svg/logo-twitter.svg?inline'
import FacebookLogo from '@/assets/svg/logo-facebook.svg?inline'
import LinkedinLogo from '@/assets/svg/logo-linkedin.svg?inline'
import GoogleLogo from '@/assets/svg/logo-googleplus.svg?inline'

export default {
  name: 'ShareLinksArticle',
  components: {
    TwitterLogo,
    FacebookLogo,
    LinkedinLogo,
    GoogleLogo,
    BaseButton,
    BaseIcon
  },
  props: {
    mobile: {
      type: Boolean,
      default: false
    },
    desktop: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    className() {
      return `${(this.mobile && 'share-tools--mobile') || ''} ${(this.desktop &&
        'share-tools--desktop') ||
        ''}`
    }
  }
}
</script>

<style lang="postcss">
.share-tools {
  @apply flex-wrap w-full justify-start items-center my-6 py-6 border border-l-0 border-r-0 border-body-lighter;
}
.share-tools--desktop {
  @apply hidden;
}
.share-tools--mobile {
  @apply flex;
}
.share-tools-text {
  @apply w-full text-left mb-2;
}
.share-tools-button {
  @apply text-white fill-current mr-2;
}
.ashare-tools-button:last-of-type {
  @apply mb-0;
}
@screen lg {
  .share-tools {
    @apply flex flex-col justify-center items-end border-none flex-1;
  }
  .share-tools--desktop {
    @apply flex absolute right-0 px-4 -mt-4 w-1/12;
  }
  .share-tools--mobile {
    @apply hidden;
  }
  .share-tools-text {
    @apply w-12 text-center;
  }
  .share-tools-button {
    @apply mb-2 mr-0;
  }
}
</style>